export enum ScanType {
    FILTERED = 'filtered',
    NOT_FILTERED = 'notFiltered',
    SELECTED = 'selected'
}
